export const REDUX_SET = '/redux/container/TurnoverContainer/set';
